module.exports = __webpack_public_path__ + "static/media/edit-icon-1.af772f26.svg";